import { Action } from 'redux';

import { SlumberActionType } from './slumber.actions';

// If the widget is asleep or not
const initialState = true;

export const slumberReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case SlumberActionType.FallAsleep:
            return true;

        case SlumberActionType.WakeUp:
            return false;

        default:
            return state;
    }
};
